import { render, staticRenderFns } from "./EventsHome.vue?vue&type=template&id=3d0213a3&scoped=true&lang=pug&"
import script from "./EventsHome.vue?vue&type=script&lang=js&"
export * from "./EventsHome.vue?vue&type=script&lang=js&"
import style0 from "./EventsHome.vue?vue&type=style&index=0&id=3d0213a3&lang=scss&scoped=true&"
import style1 from "./EventsHome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0213a3",
  null
  
)

export default component.exports